import { render } from "./HsSectionHeader.vue?vue&type=template&id=0b0be3e4&scoped=true"
import script from "./HsSectionHeader.vue?vue&type=script&lang=js"
export * from "./HsSectionHeader.vue?vue&type=script&lang=js"

import "./HsSectionHeader.vue?vue&type=style&index=0&id=0b0be3e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0be3e4"]])

export default __exports__